import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fb-card',
  template: `<p>
  MY card worksssss!!!!
</p>
`,
  styles: [``]
})
export class CardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
